

































import { Component, Prop, Vue } from "vue-property-decorator";
import { IAssessment, IAssessmentOutputs } from "../store/main.interfaces";
import {
  vocalizeBenefitSuitability,
  vocalizeEaseOfImplementation,
  vocalizeEffortToImplement
} from "../store/assessment.render";

@Component
export default class Results extends Vue {
  @Prop() assessment!: IAssessment;

  easeOfImplementationVocalization() {
    return vocalizeEaseOfImplementation(this.assessment);
  }

  benefitVocalization() {
    return vocalizeBenefitSuitability(this.assessment);
  }

  implementationEffortVocalization() {
    return vocalizeEffortToImplement(this.assessment);
  }
  showBandwidthFreed() {
    if (isNaN(this.assessment.outputs.bandwidthFreed)) {
      return 0;
    } else {
      return this.assessment.outputs.bandwidthFreed;
    }
  }
  showErrorReduction() {
    if (isNaN(this.assessment.outputs.errorReduction)) {
      return 0;
    } else {
      return this.assessment.outputs.errorReduction;
    }
  }
}
